import { Resolutions } from "../common/const";
import { isWidthResize, findAncestorByAttr } from "../common/utils";

/**
 * Блок фильтров
 * @filter
 */
class Filter {
    constructor(block) {
        this.block = block;
        this.filterItems = this.block.querySelectorAll(`[data-filter-block]`);
        this.form = this.block.querySelector(`#filter-form`);
        this.filterShowAll = this.block.querySelector(`[data-filter-show-all]`);
        this.filterScrollable = this.block.querySelector('.filter__scrollable');
        this.filterShowAllClass = 'show-all';
        this.filterOpenClass = 'filter-open';
        this.onFilterClick = this.onFilterClick.bind(this);
        this.onFilterShowAllClick = this.onFilterShowAllClick.bind(this);
        this.onResize = this.onResize.bind(this);
        // this.initScrollbar = this.initScrollbar.bind(this);
        this.closeAllFilters = this.closeAllFilters.bind(this);
    }

    // initScrollbar() {
    //     if (Resolutions.IS_TAB()) {
    //         let filterSimpleBar = new SimpleBar(this.filterScrollable);
    //     }
    // }

    closeAllFilters () {
        if (!Resolutions.IS_TAB()) {
            this.filterItems.forEach((filterItem) => filterItem.classList.remove(this.filterOpenClass));
        }
    }

    onFilterClick(e) {
        e.stopPropagation();

        const filterItem = findAncestorByAttr(e.target, 'data-filter-block');
        const filterOpen = filterItem.classList.contains(this.filterOpenClass);

        this.closeAllFilters();

        if (filterOpen) {
            filterItem.classList.remove(this.filterOpenClass);
        } else {
            filterItem.classList.add(this.filterOpenClass);
        }
    }

    onFilterShowAllClick(e) {
        e.preventDefault();
        this.block.classList.toggle(this.filterShowAllClass);
    }

    addEvents() {
        window.addEventListener(`click`, this.closeAllFilters);

        this.filterItems.forEach((filterItem) => {
            filterItem.querySelector('.filter__title').addEventListener(`click`, this.onFilterClick);
            filterItem.querySelector('.filter__body').addEventListener(`click`, (e) => {
                e.stopPropagation();
            });
        })

        this.filterShowAll.addEventListener(`click`, this.onFilterShowAllClick);
    }

    togleFilterBody() {
        if (Resolutions.IS_TAB()) {
            this.filterItems.forEach((filterItem) => {
                filterItem.classList.add(this.filterOpenClass);
            })
        } else {
            this.filterItems.forEach((filterItem) => {
                filterItem.classList.remove(this.filterOpenClass);
            })
        }
    }

    onResize() {
        // this.initScrollbar();
        this.togleFilterBody();
    }

    calcWidth() {
        const width = this.filterScrollable.offsetWidth - this.filterShowAll.parentNode.offsetWidth;
        let realWidth = 0;

        this.block.querySelectorAll(`.filter__block`).forEach((item) => {
            realWidth += item.offsetWidth;
            if (realWidth > width) {
                item.classList.add(`filter__block--hidden`);
            }
        });

        if (realWidth <= width) {
            this.filterShowAll.parentNode.style.display = `none`;
        }
    }

    init() {
        this.calcWidth();
        this.addEvents();
        // this.initScrollbar();
        this.togleFilterBody();

        isWidthResize(this.onResize);
    }
}


export const initFilter = () => {
    const elements = document.querySelectorAll('[data-filter]');
    elements.forEach((el) => new Filter(el).init());
};

window.initFilter = (block) => new Filter(block).init();
